export const SORT_BY_OLDEST_VERSION = 'OLDEST_VERSION';
export const SORT_BY_VERSION = 'VERSION';
export const SORT_BY_LAST_USED = 'LAST_USED';
export const SORT_BY_PROJECT_NAME = 'PROJECT_NAME';

export const DEFAULT_USAGE_SORT = `${SORT_BY_OLDEST_VERSION}_ASC`;

export const TOKEN_TYPE_COMPONENT = 'component';
export const TOKEN_TYPE_VERSION = 'version';
